import {
  AddTabToIndexedDB,
  CheckIndexedDBIsSupport,
  GetAllTabsFromIndexedDB,
  GetTabByIdFromIndexedDB,
  RemoveTabFromIndexedDB,
  UpdateTabMerchantIdToIndexedDB,
} from "@/IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import Cookies from "js-cookie";
import { CheckStatusSocket, SocketConnect } from "./notificationHelper";

const sessionStorageTabIdKey = "tabId";
const masterNotificationTabIdKey = "masterPeakTaxNotificationTab";

export const GetTabIdFromSessionStorage = () => {
  const tabId = sessionStorage.getItem(sessionStorageTabIdKey);
  return tabId ? parseInt(tabId) : 0;
};

const SetTabIdFromSessionStorage = (tabId: number) => {
  sessionStorage.setItem(sessionStorageTabIdKey, tabId.toString());
};

const GetMasterNotificationTabFromCookies = () => {
  const masterTabId = Cookies.get(masterNotificationTabIdKey);
  return masterTabId ? parseInt(masterTabId) : 0;
};

const SetMasterNotificationTabFromCookies = (tabId: number) => {
  Cookies.set(masterNotificationTabIdKey, tabId.toString());
};

const RemoveMasterNotificationTabFromCookies = () => {
  Cookies.remove(masterNotificationTabIdKey);
};

const RemoveMasterNotificationTabFromSessionStorage = () => {
  sessionStorage.removeItem(sessionStorageTabIdKey);
};

export const IsMasterTab = () => {
  if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
    const tabId = GetTabIdFromSessionStorage();
    const masterTabId = GetMasterNotificationTabFromCookies();
    return masterTabId == tabId;
  } else {
    return true;
  }
};
export const IsMasterTabAvailable = () => {
  const masterTabId = GetMasterNotificationTabFromCookies();
  return masterTabId > 0;
};

export const ClearTabFromSessionStorage = () => {
  RemoveMasterNotificationTabFromSessionStorage();
};

export const ClearMasterTabFromCookies = () => {
  RemoveMasterNotificationTabFromCookies();
};

const SetMasterBase = (tabId: number) => {
  SetMasterNotificationTabFromCookies(tabId);
  CheckStatusSocket();
};

export const SetMasterTab = () => {
  const tabId = GetTabIdFromSessionStorage();
  if (!IsMasterTabAvailable()) {
    SetMasterBase(tabId);
  }
};

const SetTabID = (tabId: number) => {
  SetTabIdFromSessionStorage(tabId);
};

export const InsertTabIdToTabDB = async () => {
  const tabId = await AddTabToIndexedDB();
  if (tabId > 0) {
    SetTabID(tabId);
    SetMasterTab();
    SocketConnect();
  }
};

export const UpdateTabMerchantId = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    await UpdateTabMerchantIdToIndexedDB(tabId, merchantId);
  }
};

export const RemoveTabDB = async (tabId: number) => {
  await RemoveTabFromIndexedDB(tabId);
};

export const GetAllTabs = async () => {
  return await GetAllTabsFromIndexedDB();
};

export const GetTabById = async (tabId: number) => {
  return await GetTabByIdFromIndexedDB(tabId);
};
